<template>
  <v-btn
    class="category-button"
    elevation="10"
    fab
    rounded
    x-large
    @click="emitClicked"
  >
    <div class="d-flex flex-column align-center">
      <v-icon v-if="icon">{{ icon }}</v-icon
      ><span>{{ text }}</span>
    </div></v-btn
  >
</template>

<script>
export default {
  name: 'CategoryButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
  },
  methods: {
    emitClicked() {
      this.$store.dispatch('repairTickets/setSelectedCategory', this.text);
    },
  },
};
</script>

<style lang="scss">
.category-button {
  width: 140px !important;
  height: 140px !important;
}
</style>
